// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view.agreements-view {
  background-color: var(--color-elevated-canvas);
  border: solid 1px var(--color-elevated-border);
  color: var(--color-elevated-text);
  font-size: 1.6rem;
  margin: 2rem auto;
  max-width: 40rem;
  padding: 2rem 3rem;
  text-align: left;
}
.view.agreements-view .button {
  font-size: 1.1rem;
}
.view.agreements-view .button:hover {
  background-color: var(--color-elevated-canvas);
}
.view.agreements-view .agreement-actions {
  padding-bottom: 2rem;
}
.view.agreements-view .button.accept {
  float: right;
  width: 11rem;
}
.view.agreements-view .button.decline {
  float: left;
  width: 12rem;
}
.view.agreements-view .button.email {
  float: right;
  margin-right: 2rem;
  width: 12rem;
}
.view.agreements-view .button.confirm {
  color: var(--color-elevated-warn);
}
.view.agreements-view .copy {
  font-family: Georgia;
  font-size: 1rem;
  line-height: 1.5rem;
}
.view.agreements-view .help-divider {
  border: solid 0.1rem var(--color-elevated-border);
  clear: both;
  margin: 2rem 0;
}
.view.agreements-view .logo.qci {
  display: block;
  fill: var(--color-emphasis-text);
  height: 5rem;
  margin: 1rem auto 2rem;
  opacity: 1;
}
.view.agreements-view .title {
  font-size: 1.5rem;
  font-weight: lighter;
  margin-bottom: 3rem;
  text-align: center;
}
.view.agreements-view mark {
  background: none;
  color: var(--color-elevated-text);
  text-decoration: underline;
}
.view.agreements-view li {
  margin: 1rem 0;
}
.view.agreements-view h2 {
  font-weight: bold;
  margin-top: 2rem;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/style/views/agreements.scss"],"names":[],"mappings":"AAAA;EACE,8CAAA;EACA,8CAAA;EACA,iCAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,iBAAA;AACJ;AACI;EACE,8CAAA;AACN;AAGE;EACE,oBAAA;AADJ;AAIE;EACE,YAAA;EACA,YAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;AAHJ;AAME;EACE,YAAA;EACA,kBAAA;EACA,YAAA;AAJJ;AAOE;EACE,iCAAA;AALJ;AAQE;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;AANJ;AASE;EACE,iDAAA;EACA,WAAA;EACA,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,gCAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;AARJ;AAWE;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AATJ;AAYE;EACE,gBAAA;EACA,iCAAA;EACA,0BAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;AAcE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAZJ","sourcesContent":[".view.agreements-view {\n  background-color: var(--color-elevated-canvas);\n  border: solid 1px var(--color-elevated-border);\n  color: var(--color-elevated-text);\n  font-size: 1.6rem;\n  margin: 2rem auto;\n  max-width: 40rem;\n  padding: 2rem 3rem;\n  text-align: left;\n\n  .button {\n    font-size: 1.1rem;\n\n    &:hover {\n      background-color: var(--color-elevated-canvas);\n    }\n  }\n\n  .agreement-actions {\n    padding-bottom: 2rem;\n  }\n\n  .button.accept {\n    float: right;\n    width: 11rem;\n  }\n\n  .button.decline {\n    float: left;\n    width: 12rem;\n  }\n\n  .button.email {\n    float: right;\n    margin-right: 2rem;\n    width: 12rem;\n  }\n\n  .button.confirm {\n    color: var(--color-elevated-warn);\n  }\n\n  .copy {\n    font-family: Georgia;\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n\n  .help-divider {\n    border: solid 0.1rem var(--color-elevated-border);\n    clear: both;\n    margin: 2rem 0;\n  }\n\n  .logo.qci {\n    display: block;\n    fill: var(--color-emphasis-text);\n    height: 5rem;\n    margin: 1rem auto 2rem;;\n    opacity: 1;\n  }\n\n  .title {\n    font-size: 1.5rem;\n    font-weight: lighter;\n    margin-bottom: 3rem;\n    text-align: center;\n  }\n\n  mark {\n    background: none;\n    color: var(--color-elevated-text);\n    text-decoration: underline;\n  }\n\n  li {\n    margin: 1rem 0;\n  }\n\n  h2 {\n    font-weight: bold;\n    margin-top: 2rem;\n    text-align: center;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
